var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("goodsSku.detail.BasicInformation")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _vm.isAdd
                ? [
                    _c("el-button", { on: { click: _vm.tryCancel } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ]),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessGoodsSkuOrdinary_Audit",
                            arg: "BusinessGoodsSkuOrdinary_Audit",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleConfirm(false)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("saveText")))]
                    ),
                  ]
                : _vm._e(),
              _vm.isView
                ? [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                      [_vm._v(_vm._s(_vm.$t("backText")))]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: {
            model: _vm.goodsData,
            rules: _vm.rules,
            "label-width": "230px",
            disabled: !!_vm.type,
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "SKU", prop: "skuCode" } },
                    [
                      _c("BjInput", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: "",
                          disabled: !!_vm.goodsData.id,
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.skuCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "skuCode", $$v)
                          },
                          expression: "goodsData.skuCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsPage.skuName") } },
                    [
                      _c("BjInput", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: "",
                          maxlength: _vm.MAX_LENGTH.REMARK,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.skuName,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "skuName", $$v)
                          },
                          expression: "goodsData.skuName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.ProductType") } },
                    [
                      _c("BjInput", {
                        attrs: {
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: "",
                          maxlength: _vm.MAX_LENGTH.REMARK,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.itemType,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "itemType", $$v)
                          },
                          expression: "goodsData.itemType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _vm.goodsData.id
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "goodsSku.detail.ProductClassification"
                            ),
                          },
                        },
                        [_vm._v(_vm._s(_vm.goodsData.categoryName))]
                      )
                    : _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "goodsSku.detail.ProductClassification"
                            ),
                          },
                        },
                        [
                          _c("BjGoodsTypeTreeSelect", {
                            ref: "BjGoodsTypeTreeSelect",
                            on: { change: _vm.changeCategory },
                            model: {
                              value: _vm.goodsData.categoryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.goodsData, "categoryId", $$v)
                              },
                              expression: "goodsData.categoryId",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("el-form-item", { attrs: { label: "UOM Group" } }, [
                    _vm._v("Manual"),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.UseSystemBarcode"),
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: { disabled: !!_vm.goodsData.id },
                        model: {
                          value: _vm.goodsData.asignBarcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "asignBarcode", $$v)
                          },
                          expression: "goodsData.asignBarcode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.Barcode") } },
                    [
                      _vm.goodsData.asignBarcode
                        ? _c("span", [_vm._v(_vm._s(_vm.goodsData.barCode))])
                        : _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.REMARK,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.goodsData.barCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.goodsData, "barCode", $$v)
                              },
                              expression: "goodsData.barCode",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.Supplier") } },
                    [
                      _c("BjSelectSupplier", {
                        attrs: { "page-size": 100 },
                        on: { change: _vm.changeSupplier },
                        model: {
                          value: _vm.goodsData.vendorId,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "vendorId", $$v)
                          },
                          expression: "goodsData.vendorId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.PurchasingDepartment"),
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.ROLE_LIST,
                          placeholder: _vm.$t("chooseText"),
                        },
                        on: { change: _vm.changeRole },
                        model: {
                          value: _vm.goodsData.buyingDepId,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "buyingDepId", $$v)
                          },
                          expression: "goodsData.buyingDepId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.Purchaser") } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.buyerName,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "buyerName", $$v)
                          },
                          expression: "goodsData.buyerName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.Brand") } },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.BRAND_LIST,
                          placeholder: _vm.$t("chooseText"),
                        },
                        on: { change: _vm.changeBrand },
                        model: {
                          value: _vm.goodsData.brandId,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "brandId", $$v)
                          },
                          expression: "goodsData.brandId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.packagingBarcode"),
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.cartonBoxBarcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "cartonBoxBarcode", $$v)
                          },
                          expression: "goodsData.cartonBoxBarcode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.SeasonalProducts"),
                      },
                    },
                    [_vm._v("All Seasonable")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("goodsSku.detail.Merchandiser") },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.SMALLTEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.merchandiser,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "merchandiser", $$v)
                          },
                          expression: "goodsData.merchandiser",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("goodsSku.detail.Merchandiser2") },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.SMALLTEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.merchandiser2,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "merchandiser2", $$v)
                          },
                          expression: "goodsData.merchandiser2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("goodsSku.detail.ContinueSell") },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.goodsData.discontinued,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "discontinued", $$v)
                          },
                          expression: "goodsData.discontinued",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.costPrice") } },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.costPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "costPrice", $$v)
                          },
                          expression: "goodsData.costPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.salesPrice") } },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.salesPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "salesPrice", $$v)
                          },
                          expression: "goodsData.salesPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("goodsSku.detail.activityPrice") },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.activityPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "activityPrice", $$v)
                          },
                          expression: "goodsData.activityPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.marketPrice") } },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.marketPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "marketPrice", $$v)
                          },
                          expression: "goodsData.marketPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.distributionPrice"),
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.distributionPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "distributionPrice", $$v)
                          },
                          expression: "goodsData.distributionPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.wholesalePrice"),
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.wholesalePrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "wholesalePrice", $$v)
                          },
                          expression: "goodsData.wholesalePrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("goodsSku.detail.clearingPrice") },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.clearingPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "clearingPrice", $$v)
                          },
                          expression: "goodsData.clearingPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "RMB" } },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.rmb,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "rmb", $$v)
                          },
                          expression: "goodsData.rmb",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsPage.Actual") } },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.actualProfitRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "actualProfitRate", $$v)
                          },
                          expression: "goodsData.actualProfitRate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsPage.Standard") } },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.standardProfitRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "standardProfitRate", $$v)
                          },
                          expression: "goodsData.standardProfitRate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsPage.rate") } },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.MINITEXT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.resendRefundRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "resendRefundRate", $$v)
                          },
                          expression: "goodsData.resendRefundRate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsPage.Predicted") } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.goodsData.isPrediction,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "isPrediction", $$v)
                          },
                          expression: "goodsData.isPrediction",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.InventoryProducts"),
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.goodsData.inventoryItem,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "inventoryItem", $$v)
                          },
                          expression: "goodsData.inventoryItem",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.PurchasedItems"),
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.goodsData.purchaseItem,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "purchaseItem", $$v)
                          },
                          expression: "goodsData.purchaseItem",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("goodsSku.detail.SellingItems") },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.goodsData.salesItem,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "salesItem", $$v)
                          },
                          expression: "goodsData.salesItem",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.Fragile") } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.goodsData.fragile,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "fragile", $$v)
                          },
                          expression: "goodsData.fragile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.DangerousGoods"),
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.goodsData.dangerousGoods,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "dangerousGoods", $$v)
                          },
                          expression: "goodsData.dangerousGoods",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.Flammable") } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.goodsData.flammable,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "flammable", $$v)
                          },
                          expression: "goodsData.flammable",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.Picture") } },
                    [
                      _c(
                        "BjUpload",
                        {
                          ref: "BjUpload",
                          staticClass: "avatar-uploader",
                          attrs: {
                            "auto-upload": "",
                            accept: "image/png,image/jpeg",
                            "accept-list": ["image/jpeg", "image/png"],
                            "limit-size": 100,
                          },
                          on: { afterUpload: _vm.afterUpload },
                        },
                        [
                          _c(
                            "template",
                            { slot: "default" },
                            [
                              _vm.goodsData.imageUrl
                                ? _c("BjKeyImage", {
                                    staticClass: "avatar",
                                    attrs: {
                                      url: _vm.goodsData.imageUrl,
                                      fit: "cover",
                                    },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "BjDivider",
                [
                  _vm._v(
                    _vm._s(_vm.$t("goodsSku.detail.CertificateList")) + " "
                  ),
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addSkuLicense },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                  ],
                ],
                2
              ),
              _c(
                "el-table",
                {
                  ref: "storeTable",
                  attrs: {
                    data: _vm.goodsData.skuLicenseList,
                    stripe: "",
                    border: "",
                    "header-cell-style": _vm.$rowStyle.DEFAULT,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "licenseName",
                      label: _vm.$t("goodsSku.detail.CertificateName"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("BjInput", {
                              attrs: {
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                                clearable: "",
                              },
                              model: {
                                value: scope.row.licenseName,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "licenseName", $$v)
                                },
                                expression: "scope.row.licenseName",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "licenseExpireDate ",
                      label: _vm.$t("goodsSku.detail.CertificatePeriod"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("BjDatePicker", {
                              attrs: { "value-format": "yyyy-MM-dd HH:mm:ss" },
                              model: {
                                value: scope.row.licenseExpireDate,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "licenseExpireDate", $$v)
                                },
                                expression: "scope.row.licenseExpireDate",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "licenseNode",
                      label: _vm.$t("goodsSku.detail.CertificateRemarks"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("BjInput", {
                              attrs: {
                                maxlength: _vm.MAX_LENGTH.REMARK,
                                placeholder: _vm.$t("inputText"),
                                clearable: "",
                              },
                              model: {
                                value: scope.row.licenseNode,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "licenseNode", $$v)
                                },
                                expression: "scope.row.licenseNode",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action",
                      label: _vm.$t("operationText"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goodsData.skuLicenseList.splice(
                                      scope.$index,
                                      1
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delText")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v(_vm._s(_vm.$t("goodsSku.detail.AttributeTable"))),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.length"),
                        prop: "length",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.goodsData.length,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "length", $$v)
                            },
                            expression: "goodsData.length",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.width"),
                        prop: "width",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.goodsData.width,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "width", $$v)
                            },
                            expression: "goodsData.width",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.height"),
                        prop: "height",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.goodsData.height,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "height", $$v)
                            },
                            expression: "goodsData.height",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.weight"),
                        prop: "weight",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.goodsData.weight,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "weight", $$v)
                            },
                            expression: "goodsData.weight",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("kg")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.UnitVolume") } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            (_vm.goodsData.width *
                              _vm.goodsData.height *
                              _vm.goodsData.length) /
                              1000000
                          ) +
                          "m³ "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.qty"),
                        prop: "qty",
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.goodsData.qty,
                          callback: function ($$v) {
                            _vm.$set(_vm.goodsData, "qty", $$v)
                          },
                          expression: "goodsData.qty",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.cartonLength"),
                        prop: "cartonLength",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.goodsData.cartonLength,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "cartonLength", $$v)
                            },
                            expression: "goodsData.cartonLength",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.cartonWidth"),
                        prop: "cartonWidth",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.goodsData.cartonWidth,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "cartonWidth", $$v)
                            },
                            expression: "goodsData.cartonWidth",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.cartonHeight"),
                        prop: "cartonHeight",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.goodsData.cartonHeight,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "cartonHeight", $$v)
                            },
                            expression: "goodsData.cartonHeight",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("cm")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsSku.detail.cartonWeight"),
                        prop: "cartonWeight",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.NORMAL,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.goodsData.cartonWeight,
                            callback: function ($$v) {
                              _vm.$set(_vm.goodsData, "cartonWeight", $$v)
                            },
                            expression: "goodsData.cartonWeight",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("kg")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("goodsSku.detail.Volume") } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            (_vm.goodsData.cartonWidth *
                              _vm.goodsData.cartonHeight *
                              _vm.goodsData.cartonLength) /
                              1000000
                          ) +
                          "m³ "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }